import { Link } from "react-router";
import { cn } from "@util/helpers";

type FooterLinksType = {
  /** label is used to display text for footer navigation items */
  label: string;
  /** link is used for the navigation of the footer items */
  link: string;
};

type FooterMenuLinksProps = {
  /** List of items used for the navigation of the footer items */
  items: FooterLinksType[];
  //** Extra class used for styling of footer link items */
  className?: string;
};

/**
 * Component to render footer links for footer component in SBA pages
 */
const FooterMenuLinks = ({
  items,
  className,
}: FooterMenuLinksProps): React.ReactElement => {
  return (
    <div
      className={cn("flex flex-col", className)}
      data-testid="footer-menu-links-component"
    >
      {items.map((item) => (
        <Link
          to={`${item.link}?ref=footer`}
          key={item.label}
          className="text-left text-base text-white hover:text-white/75"
          reloadDocument
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default FooterMenuLinks;
